export type TextVariant =
  // Heading
  | 'h1-regular'
  | 'h1-bold'
  | 'h2-regular'
  | 'h2-bold'
  | 'h3-regular'
  | 'h3-bold'
  // Title
  | 'title-regular'
  | 'title-bold'
  // Body
  | 'body-regular'
  | 'body-bold'
  // SM
  | 'sm-regular'
  | 'sm-bold'
  // XS
  | 'xs-regular'
  | 'xs-bold'
  // Legacy (from old Medusa starter)
  | 'xsmall-regular'
  | 'small-regular'
  | 'small-semi'
  | 'base-regular'
  | 'base-semi'
  | 'large-regular'
  | 'large-semi'
  | 'xl-regular'
  | 'xl-semi'
  | '2xl-regular'
  | '2xl-semi'
  | '3xl-regular'
  | '3xl-semi';

export const variantStyles: Record<TextVariant, string> = {
  // Primary design system
  'h1-regular': 'text-4xl font-normal',
  'h1-bold': 'text-4xl font-bold',
  'h2-regular': 'text-[30px] font-normal leading-[38px]',
  'h2-bold': 'text-[30px] font-bold leading-[38px]',
  'h3-regular': 'text-2xl font-normal',
  'h3-bold': 'text-2xl font-bold',
  'title-regular': 'text-xl font-normal',
  'title-bold': 'text-xl font-bold',
  'body-regular': 'text-base font-normal',
  'body-bold': 'text-base font-bold',
  'sm-regular': 'text-sm font-normal',
  'sm-bold': 'text-sm font-bold',
  'xs-regular': 'text-xs font-normal',
  'xs-bold': 'text-xs font-bold',

  // Legacy variants
  'xsmall-regular': 'text-[10px] font-normal leading-4',
  'small-regular': 'text-xs font-normal leading-5',
  'small-semi': 'text-xs font-semibold leading-5',
  'base-regular': 'text-sm font-normal leading-6',
  'base-semi': 'text-sm font-semibold leading-6',
  'large-regular': 'text-base font-normal leading-6',
  'large-semi': 'text-base font-semibold leading-6',
  'xl-regular': 'text-2xl font-normal leading-[36px]',
  'xl-semi': 'text-2xl font-semibold leading-[36px]',
  '2xl-regular': 'text-[30px] font-normal leading-[48px]',
  '2xl-semi': 'text-[30px] font-semibold leading-[48px]',
  '3xl-regular': 'text-[32px] font-normal leading-[44px]',
  '3xl-semi': 'text-[32px] font-semibold leading-[44px]',
};
